import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectAuthLoading } from "../redux/slices/authSlice";

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const loading = useSelector(selectAuthLoading);

    console.log(
        "ProtectedRoute - loading:",
        loading,
        "isAuthenticated:",
        isAuthenticated
    );
    console.log("ProtectedRoute - pathname:", location.pathname);

    // Show loading while authentication state is being determined
    if (loading) {
        return (
            <div className="dashboard-loading">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading dashboard...</p>
                </div>
            </div>
        );
    }

    // Only redirect to login if trying to access dashboard routes and user is not authenticated
    if (!isAuthenticated && location.pathname.startsWith("/dashboard")) {
        console.log("ProtectedRoute - redirecting to login");
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    console.log("ProtectedRoute - allowing access");
    return children;
};

export default ProtectedRoute;
